import styled from 'styled-components'
import { PRIMARY_TEXT } from 'constants/colors'

export const ListItemWrapper = styled.div`
  > li.MuiListItem-root.MuiListItem-gutters {
    padding: 10px 0 10px 25px;
    color: ${PRIMARY_TEXT};
    opacity: 0.4;
    line-height: 20px;
  }
`
